module.exports = __webpack_public_path__ + "img/icon-home.f828d6aa.svg";